import CampaignName from './CampaignName';
import Product from './Product';
import StartDate from './StartDate';
import EndDate from './EndDate';
import Cities from './Cities';
import CampaignStatus from './CampaignStatus';
import CreatedBy from './CreatedBy';
import AdPacing from './AdPacing';
export default {
    CampaignName,
    Product,
    StartDate,
    EndDate,
    Cities,
    CampaignStatus,
    CreatedBy,
    AdPacing,
};
